export default "__VITE_ASSET__cad11b8f__"